<template>
  <div id="myTicket">
    <div class="content_box">
      <div class="inner">
        <!-- <div class="contact_title">
          <h2 class="support_ticket">{{ $t('supportTickets.mySupportTickets') }}</h2>
          <p></p>
        </div> -->
        <global-title :title="$t('supportTickets.mySupportTickets')"></global-title>
        <div class="ticket_header">
          <div>
            <el-select v-model="selectedTab" placeholder="选择状态" className="ticket_select">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="`${$t('supportTickets.tabStatus.' + item.label)} ${
                  ticketList[item.label].length > 0 ? '(' + ticketList[item.label].length + ')' : ''
                }`"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-button @click="onCreateNewTicket" class="blue_button mb-8">{{
            $t('supportTickets.createNewTicket')
          }}</el-button>
        </div>
        <div class="ticket_body">
          <el-table :data="ticketList[selectedTab]" :row-class-name="rowClassName" style="width: 100%">
            <el-table-column type="index" :label="$t('supportTickets.number')" width="110"></el-table-column>
            <el-table-column prop="id" :label="$t('supportTickets.ticketNo')" min-width="150">
              <template slot-scope="scope">
                <span class="action-button underline" @click="onTicketClick(scope.row)">
                  {{ scope.row.id }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('supportTickets.description')" min-width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.description.length < 20">
                  <span v-html="sanitizeContent(scope.row.description)"></span>
                </span>
                <span v-else>
                  <span
                    class="support-ticket-description"
                    v-html="sanitizeContent(scope.row.description).substring(0, 20)"
                  ></span>
                  ...
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('supportTickets.status')" min-width="150">
              <template slot-scope="scope">
                <span class="status action-button underline" @click="onTicketClick(scope.row)">
                  {{ $t('supportTickets.tabStatus.' + scope.row.status) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="updatedAtDisplay"
              :label="$t('supportTickets.lastUpdated')"
              min-width="150"
            ></el-table-column>
            <div slot="empty" class="empty">
              <img class="noData_icon" src="@/assets/images/no_data.png" alt />
              <div>{{ $t('loyalty.noData') }}</div>
            </div>
          </el-table>
        </div>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="ticketDialog" top="30px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="dialog_body"> -->
    <Dialog :show.sync="ticketDialog" :top="'30'" @onDialogClose="onDialogClose">
      <Ticket
        :ticketDialog.sync="ticketDialog"
        v-if="showTicket"
        :data="ticketData"
        @onTicketDialogClose="onDialogClose"
        @createNewTicket="onCreateNewTicket"
      />
      <NewTicket
        v-if="showNewTicket"
        :ticketDialog.sync="ticketDialog"
        :data="ticketData"
        @onTicketDialogClose="onDialogClose"
      />
    </Dialog>
    <!-- </div>
    </el-dialog> -->
  </div>
</template>

<script>
import NewTicket from '@/components/support/NewTicket';
import Ticket from '@/components/support/Ticket';
import { apiTicketRequest } from '@/resource';
import DOMPurify from 'dompurify';
import GlobalTitle from '@/components/global/title';
import Dialog from '@/components/global/Dialog';

const ALL = 'all';
const NEW = 'new';
const OPEN = 'open';
const SOLVED = 'solved';
const HOLD = 'hold';
const PENDING = 'pending';
const CLOSED = 'closed';

const defaultTicketList = {
  [ALL]: [],
  [NEW]: [],
  [OPEN]: [],
  [PENDING]: [],
  // [HOLD]: [],
  [SOLVED]: [],
  [CLOSED]: []
};

export default {
  components: { Ticket, NewTicket, GlobalTitle, Dialog },
  data() {
    return {
      options: [
        {
          value: 'all',
          label: 'all'
        },
        {
          value: 'new',
          label: 'new'
        },
        {
          value: 'pending',
          label: 'pending'
        },
        {
          value: 'open',
          label: 'open'
        },
        {
          value: 'solved',
          label: 'solved'
        },
        {
          value: 'closed',
          label: 'closed'
        }
      ],
      filterButtons: [
        ALL,
        NEW,
        PENDING,
        OPEN,
        SOLVED,
        // HOLD,
        CLOSED
      ],
      selectedTab: 'all',
      ticketList: JSON.parse(JSON.stringify(defaultTicketList)),
      ticketDialog: false,
      showTicket: false,
      showNewTicket: false,
      ticketData: {}
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      apiTicketRequest()
        .then(resp => {
          if (resp.data.code !== 0) {
            return;
          }
          const filterList = [HOLD];
          const allData = resp.data.data.requests;
          this.ticketList.all = allData.filter(ticket => !filterList.includes(ticket.status));
          allData.forEach(item => {
            if (!filterList.includes(item.status)) {
              this.ticketList[item.status].push(item);
              console.log('Ticket List Updated!!');
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    onTicketClick(ticket) {
      this.ticketDialog = true;
      this.showTicket = true;
      this.showNewTicket = false;
      this.ticketData = ticket;
    },
    onCreateNewTicket() {
      this.ticketDialog = true;
      this.showTicket = false;
      this.showNewTicket = true;
    },
    onDialogClose(refresh) {
      this.ticketDialog = false;
      this.showNewTicket = false;
      this.showTicket = false;
      if (refresh) {
        this.ticketList = JSON.parse(JSON.stringify(defaultTicketList));
        this.fetchList();
      }
    },
    sanitizeContent(values) {
      return DOMPurify.sanitize(values);
    },
    rowClassName(data) {
      return data.row.status === 'pending' ? 'pending-row' : '';
    }
  }
};
</script>

<style lang="scss" scoped>
// @import '@/assets/css/pages/myTickets.scss';

#myTicket {
  .action-button {
    cursor: pointer;
  }

  .ticket_header {
    display: flex;
    justify-content: space-between;
    .ticket_select {
      width: 182px;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      .blue_button {
        margin-top: 24px;
        background-color: #fff;
        color: #0051ff;
        border: 1px solid #0051ff;
      }
      .ticket_select {
        width: auto;
      }
    }
  }

  // .ticket_body {
  //   margin-top: 30px;
  // }

  .tab_nav {
    width: 80%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 5px;

    @media (min-width: 550px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (min-width: 1225px) {
      grid-template-columns: repeat(7, minmax(0, 1fr));
    }

    @media (min-width: 1500px) {
      grid-template-columns: repeat(8, minmax(0, 1fr));
    }

    .tab_item {
      color: #000d28;
      border: 1px solid #000d28;
      justify-content: center;
      border-radius: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      text-align: center;
      height: 40px;
      text-transform: capitalize;

      &:hover {
        border: 1px solid $primary-blue;
        background-color: $primary-blue;
        color: white;
      }

      &.active {
        border: 1px solid $primary-blue;
        background-color: $primary-blue;
        color: white;
      }
    }
  }

  .support_ticket {
    font-weight: bold;
  }

  .support-ticket-description {
    display: inline-block;
  }

  /deep/ .pending-row {
    td .status {
      color: #f41112 !important;
    }
  }
  /deep/ .el-dialog__headerbtn {
    @include rtl-sass-prop-sd(right, unset);
  }
}
</style>
